"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable import/no-anonymous-default-export,import/no-default-export */
exports.default = {
    sm: '0px',
    md: '2px',
    lg: '5px',
    xl: '11px',
    round: '100%',
    //in progress of new radius definition
    unstable_new: {
        sm: '0',
        md: '4px',
        lg: '8px',
        xl: '16px',
    },
};
//# sourceMappingURL=radius.js.map